const DELETED_CANVAS_SUCCESS_MESSAGE = 'Canvas deleted successfully';
const DELETED_CANVASES_SUCCESS_MESSAGE = 'Canvases deleted successfully';

let pendingCanvasId: string | null = null;
const listeners = new Set<() => void>();

const emitOwnCanvasDeleteRedirect = () => {
  for (const listener of listeners) {
    listener();
  }
};

export const getDeletedCanvasesSuccessMessage = (count: number) =>
  count === 1 ? DELETED_CANVAS_SUCCESS_MESSAGE : DELETED_CANVASES_SUCCESS_MESSAGE;

type ShowCanvasDeletedToastParams = {
  message: string;
  /** Resolves after `routeChangeComplete`. HomeLayout dismisses toasts in that event. */
  onRedirect?: () => Promise<unknown>;
  showToast: (message: string) => void;
};

/**
 * HomeLayout clears every toast on `routeChangeComplete`, and that listener runs before
 * `router.replace` resolves. Leave the page first, then show the confirmation, so the
 * dismiss does not eat it. A delete that stays on the page has no redirect and toasts immediately.
 */
export const showCanvasDeletedToast = async ({ message, onRedirect, showToast }: ShowCanvasDeletedToastParams) => {
  if (onRedirect) {
    await onRedirect();
  }

  showToast(message);
};

export const beginOwnCanvasDeleteRedirect = (canvasId: string) => {
  pendingCanvasId = canvasId;
  emitOwnCanvasDeleteRedirect();
};

export const clearOwnCanvasDeleteRedirect = (canvasId: string) => {
  if (pendingCanvasId !== canvasId) {
    return;
  }

  pendingCanvasId = null;
  emitOwnCanvasDeleteRedirect();
};

export const getOwnCanvasDeleteRedirectCanvasId = () => pendingCanvasId;

export const getServerOwnCanvasDeleteRedirectCanvasId = () => null;

export const subscribeOwnCanvasDeleteRedirect = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};
